const colors = {
  yellow: {
    light: '#FFFCEA',
    main: '#FFE521',
    dark: '#E9D11F',
  },
  magenta: {
    light: '#FFF4FB',
    main: '#FB5EBF',
    dark: '#CD4F9D',
  },
  mint: {
    light: '#77F9AE',
    main: '#56F89A',
    dark: '#3CAD6B',
  },
  black: {
    light: '#222',
    main: '#111',
    dark: '#000',
  },
  white: {
    main: '#FFF',
  },
  background: {
    main: '#FFF',
    // paper: '#F2F2F2',
  },
  error: {
    main: '#FA3201',
  },
  warning: {
    main: '#FFB300',
  },
  success: {
    main: '#00B503',
  },
};

export default colors;
